import { useState } from "react"
import useDashboardConfig, {
  DASHBOARD_VIEW_SELECTED,
} from "./useDashboardConfig"
import useDashboardConfigFilters from "./useDashboardConfigFilters"
export const CARD_VIEW = 0
export const TABLE_VIEW = 1

const useDashboardComponent = () => {
  const dashboardConfig = useDashboardConfig()
  const dashboardConfigFilters = useDashboardConfigFilters(dashboardConfig)

  const [config, updateConfig] = dashboardConfig
  const [view, setView] = useState(config[DASHBOARD_VIEW_SELECTED] ?? CARD_VIEW)

  const setViewMode = newView => {
    setView(newView)
    updateConfig(DASHBOARD_VIEW_SELECTED, newView)
  }

  return {
    dashboardConfig,
    dashboardConfigFilters,
    setViewMode,
    view,
  }
}

export default useDashboardComponent
